(function () {
  function init() {
    document.querySelectorAll('.ff-wrapper[data-count]').forEach(function (el) {
      if (el.dataset.ffInit) return;
      el.dataset.ffInit = 'true';

      var count    = parseInt(el.dataset.count, 10);
      if (count <= 1) return;

      var showDots = el.dataset.showDots === 'true';

      el.classList.add('splide');
      var track = el.querySelector('.ff-track');
      var list  = el.querySelector('.ff-list');
      if (track) track.classList.add('splide__track');
      if (list)  list.classList.add('splide__list');
      el.querySelectorAll('.ff-slide').forEach(function (slide) {
        slide.classList.add('splide__slide');
      });

      new Splide(el, {
        type:       'loop',
        perPage:    1,
        perMove:    1,
        arrows:     false,
        pagination: showDots,
        autoplay:   false,
      }).mount();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();
